module.exports = __webpack_public_path__ + "static/media/scholorimg-1.a304dd10.png";